import COMPONENT_STATUSES from './componentStatuses';

export default {
  Operational: COMPONENT_STATUSES.OPERATIONAL,
  Printing: COMPONENT_STATUSES.BUILDING,
  Paused: COMPONENT_STATUSES.BUILD_PAUSED
};
